const mainGoalsList = [
    {
        categoryId: 31803,
        asSecondaryGoal: 31811,
        name: "Hiilineutraali yhteiskunta",
        srcImg: "hiilineutraali-yhteiskunta.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31820,
            31825,
            31827,
            31831,
            31833,
            31835,
        ]
    },
    {
        categoryId: 31804,
        asSecondaryGoal: 31812,
        name: "Kestävät elämäntavat",
        srcImg: "kestavat-elamantavat.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31830,
            31822,
            31826,
            31827,
            31835
        ]
    },
    {
        categoryId: 31805,
        asSecondaryGoal: 31813,
        name: "Kestävät yhdyskunnat",
        srcImg: "kestavat-yhdyskunnat.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31821,
            31828,
            31829,
            31831,
            31834,
            31835
        ]
    },
    {
        categoryId: 31806,
        asSecondaryGoal: 31814,
        name: "Luontoa kunnioittava päätöksenteko",
        srcImg: "luontoa-kunnioittava-paatoksenteko.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31821,
            31824,
            31830,
            31832,
            31833,
            31834,
            31835
        ]
    },
    {
        categoryId: 31807,
        asSecondaryGoal: 31815,
        name: "Resurssiviisas talous",
        srcImg: "resurssiviisas-talous.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31820,
            31824,
            31825,
            31826,
            31827,
            31830,
            31833,
            31835
        ]
    },
    {
        categoryId: 31808,
        asSecondaryGoal: 31816,
        name: "Työtä kestävästi",
        srcImg: "tyota-kestavasti.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31822,
            31826,
            31827,
            31830,
            31834,
            31835
        ]
    },
    {
        categoryId: 31809,
        asSecondaryGoal: 31817,
        name: "Vaikuttavien kansalaisten yhteiskunta",
        srcImg: "vaikuttavien-kansalaisten-yhteiskunta.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31822,
            31828,
            31834,
            31835
        ]
    },
    {
        categoryId: 31810,
        asSecondaryGoal: 31818,
        name: "Yhdenvertaisuus",
        srcImg: "yhdenvertaisuus.png",
        active: false,
        canModify: true,
        agendaGoals: [
            31819,
            31820,
            31821,
            31822,
            31823,
            31826,
            31828,
            31834,
            31835
        ]
    }
]
const mainGoalsListNew = [
    {
        categoryId: 747968, // TEST: 667399, DEV: 653204
        asSecondaryGoal: 747980,
        name: "Hyvinvointia edistävä talous ja työ sekä kestävä kulutus",
        nameEn: "Economy and work promoting wellbeing and sustainable consumption",
        srcImg: "economy.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31826, // 8 työtä ja talouskasvua
            31827, // 9 kestävää teollisuutta
            31830 // 12 kuluttaminen
        ]
    },
    {
        categoryId: 747970, // TEST: 667401, DEV: 656445
        asSecondaryGoal: 747982,
        name: "Sivistys, osaaminen ja kestävät elämäntavat",
        nameEn: "Education, competence and sustainable lifestyles",
        srcImg: "education.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31822, // 4 hyvä koulutus
            31823, // 5 sukupuolten tasa-arvo
            31828, // 10 eriarvoisuuden vähentäminen
            31831 // 13 ilmastotekoja
        ]
    },
    {
        categoryId: 747972,
        asSecondaryGoal: 747984,
        name: "Hyvinvointi, terveys ja yhteiskunnallinen osallisuus",
        nameEn: "Wellbeing, health and social inclusion",
        srcImg: "wellbeing.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31819, // 1 ei köyhyyttä
            31821, // 3 terveyttä ja hyvinvointia
            31823, // 5 sukupuolten tasa-arvo
            31828, // 10 eriarvoisuuden vähentäminen
            31834 // 16 rauha ja hallinto
        ]
    },
    {
        categoryId: 747974,
        asSecondaryGoal: 747986,
        name: "Hyvinvointia edistävä ruokajärjestelmä",
        nameEn: "Food system promoting wellbeing",
        srcImg: "food.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31820, // 2 ei nälkää
            31824, // 6 puhdas vesi
            31830, // 12 kuluttaminen
            31831, // 13 ilmastotekoja
            31832, // 14 vedenalainen
            31833 // 15 maanpäällinen
        ]
    },
    {
        categoryId: 747976,
        asSecondaryGoal: 747988,
        name: "Monimuotoisuutta ja hiilineutraaliutta vahvistava metsien, vesien ja maan käyttö",
        nameEn: "Forest, water and land use promoting biodiversity",
        srcImg: "environment.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31820, // 2 ei nälkää
            31824, // 6 puhdas vesi
            31829, // 11 kestävät kaupungit
            31833 // 15 maanpäällinen
        ]
    },
    {
        categoryId: 747978,
        asSecondaryGoal: 747990,
        name: "Kestävä energiajärjestelmä",
        nameEn: "Sustainable energy system",
        srcImg: "energy.png",
        active: false,
        canModify: true,
        newww: true,
        agendaGoals: [
            31825, // 7 puhdasta energiaa
            31827, // 9 kestävää teollisuutta
            31830, // 12 kuluttaminen
            31831 // 13 ilmastotekoja
        ]
    }
]

const agendaGoalsList = [
    {
        categoryId: 31819,
        srcImg: "1_ei-koyhyytta.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31820,
        srcImg: "2_ei-nalkaa.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31821,
        srcImg: "3_terveytta-ja-hyvinvointia.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31822,
        srcImg: "4_hyva-koulutus.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31823,
        srcImg: "5_sukupuolten-tasa-arvo.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31824,
        srcImg: "6_puhdas-vesi-ja-sanitaatio.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31825,
        srcImg: "7_edullista-ja-puhdasta-energiaa.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31826,
        srcImg: "8_ihmisarvoista-tyota-ja-talouskasvua.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31827,
        srcImg: "9_kestavaa-teollisuutta.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31828,
        srcImg: "10_eriarvoisuuden-vahentaminen.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31829,
        srcImg: "11_kestavat-kaupungit.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31830,
        srcImg: "12_vastuullista-kuluttamista.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31831,
        srcImg: "13_ilmastotekoja.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31832,
        srcImg: "14_vedenalainen-elama.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31833,
        srcImg: "15_maanpaallinen-elama.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31834,
        srcImg: "16_rauha-oikeudenmukaisuus-ja-hyva-hallinto.svg",
        active: false,
        canModify: true,
    },
    {
        categoryId: 31835,
        srcImg: "17_yhteistyo-ja-kumppanuus.svg",
        active: false,
        canModify: true,
    },

]

export {mainGoalsList, mainGoalsListNew, agendaGoalsList};


// WEBPACK FOOTER //
// ./src/constants/GoalsMap.js